export const BRANDING = {
  publicName: 'Olhos do Campus',
  officialName: 'Sistema Institucional de Manutenção da Infraestrutura Física',
  tagline: 'Ajude-nos a cuidar e melhorar os espaços do campus.',
  institution: 'Instituto Federal do Espírito Santo — Campus Barra de São Francisco',
  horizontalBrandPath: '/brand/ifes-bsf-horizontal.jpg',
  verticalBrandPath: '/brand/ifes-bsf-vertical.jpg',
  brandAlt: 'Instituto Federal do Espírito Santo — Campus Barra de São Francisco',
} as const;
